module.exports = __webpack_public_path__ + "static/media/img_fenlei11.a305ef9e.png";